import { faFoursquare } from '@fortawesome/free-brands-svg-icons';
import { faCheck, faPlus, faStarOfLife, faFilter, faCircleStop, faArrowDownAZ, faSquarePlus, faMinus, faFloppyDisk, faRotateLeft, faLink, faSpinner, faMagnifyingGlass, faTimesCircle, faClock, faFile, faClose, faRightFromBracket, faCircleArrowLeft, faMagnifyingGlassPlus, faCircleCheck, faTrash, faCirclePlus, faTrashCan, faXmark, faMinusSquare, faPlusSquare, faBox, faBoxOpen, faSquare, faDownload, faCalendar } from '@fortawesome/free-solid-svg-icons';
export const EMDMICONS = {
    FACHECK: faCheck,
    FACIRCLE: faRotateLeft,
    FACIRCLEPLUS: faCirclePlus,
    FATRASHCAN: faTrashCan,
    FAXMARK: faXmark,
    FACIRCLECHECK: faCircleCheck,
    FACIRCLEHOLLOW: faCircleStop,
    FASEARCH: faMagnifyingGlass,
    FACLOSE: faClose,
    FARIGHTCHECK: faRightFromBracket,
    FACIRCLEARROWLEFT: faCircleArrowLeft,
    FASEARCHPLUS: faMagnifyingGlassPlus,
    FASPINNER: faSpinner,
    FATIMESCLOCK: faTimesCircle,
    FACLOCK: faClock,
    FAFILE: faFile,
    FAFILEDELETE: faTrash,
    FAPLUS: faPlus,
    FASQUAREPLUS: faSquarePlus,
    FAMINUSSQUARE: faMinusSquare,
    FAMINUS: faMinus,
    FASTAR: faStarOfLife,
    FALINK: faLink,
    FASAVE: faFloppyDisk,
    FASORT: faArrowDownAZ,
    FAFILTER: faFilter,
    FATRASH : faTrash,
    FADOWNLOAD: faDownload,
    FACALENDAR : faCalendar
};